import { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  borderRadius: "10px 10px 0 0", // top-left & top-right corners only
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // soft bottom shadow
  marginBottom: "10px", // space between accordions
  overflow: "hidden",
  "&:not(:first-of-type)": {
    borderTop: "1px solid #ddd", // optional subtle border
  },
}));

export default function TechQuestion() {
  const [expanded, setExpanded] = useState("panel1");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      <StyledAccordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h5">Question 1</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>Answer 1</Typography>
        </AccordionDetails>
      </StyledAccordion>

      <StyledAccordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h5">Question 2</Typography>
        </AccordionSummary>
        <AccordionDetails>Answer 2 </AccordionDetails>
      </StyledAccordion>

      <StyledAccordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h5">Question 3</Typography>
        </AccordionSummary>
        <AccordionDetails>Answer 3 </AccordionDetails>
      </StyledAccordion>
    </div>
  );
}
